/**
 * MatchmakingManager - Hızlı Eşleşme Modu Yöneticisi
 * Colyseus matchmaking ile otomatik eşleşme
 */

const MatchmakingManager = {
    selectedPlayerCount: 2,
    isSearching: false,
    currentRoom: null,
    elements: {},
    initialized: false,

    init() {
        // Her init çağrısında elementleri yeniden cache et
        this.cacheElements();
        this.setupListeners();
        this.initialized = true;
        console.log("⚔️ MatchmakingManager initialized");
    },

    cacheElements() {
        this.elements = {
            competitionPanel: document.getElementById('competition-panel'),
            playerCountBtns: document.querySelectorAll('.player-count-btn'),
            startBtn: document.getElementById('start-matchmaking-btn'),
            cancelBtn: document.getElementById('cancel-matchmaking-btn'),
            statusContainer: document.getElementById('matchmaking-status'),
            statusText: document.querySelector('.matchmaking-status .status-text'),
            showCompetitionBtn: document.getElementById('show-competition-btn'),
            closeCompetitionBtn: document.getElementById('close-competition-panel'),
            startGameBtn: document.getElementById('start-game-competition-btn') // [NEW]
        };
    },

    setupListeners() {
        // Oyuncu sayısı seçimi
        this.elements.playerCountBtns?.forEach(btn => {
            btn.onclick = () => {
                this.elements.playerCountBtns.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                this.selectedPlayerCount = parseInt(btn.dataset.count);
                console.log(`⚔️ Player count selected: ${this.selectedPlayerCount}`);
            };
        });

        // Oyun ara butonu
        if (this.elements.startBtn) {
            this.elements.startBtn.onclick = () => this.startSearch();
        }

        // İptal butonu
        if (this.elements.cancelBtn) {
            this.elements.cancelBtn.onclick = () => this.cancelSearch();
        }

        // Panel açma butonu
        if (this.elements.showCompetitionBtn) {
            this.elements.showCompetitionBtn.onclick = () => {
                console.log("⚔️ Show competition panel clicked");
                this.showPanel();
            };
        }

        // Panel kapatma butonu
        if (this.elements.closeCompetitionBtn) {
            this.elements.closeCompetitionBtn.onclick = () => this.hidePanel();
        }

        // [NEW] Oyunu Başlat butonu
        if (this.elements.startGameBtn) {
            this.elements.startGameBtn.onclick = () => {
                if (this.currentRoom) {
                    console.log("⚔️ User clicked Start Game -> Sending playerReady");
                    this.currentRoom.send("playerReady");

                    // Butonu güncelle
                    this.elements.startGameBtn.disabled = true;
                    this.elements.startGameBtn.innerHTML = "⏳ Diğerleri Bekleniyor...";
                    this.elements.startGameBtn.classList.remove('pulse-btn');
                }
            };
        }
    },

    showPanel() {
        console.log("⚔️ showPanel called");

        // Elementleri yeniden cache et (dinamik DOM için)
        this.cacheElements();

        // Diğer panelleri gizle
        document.querySelectorAll('.lobby-panel').forEach(p => p.classList.add('hidden'));
        document.getElementById('lobby-main-actions')?.classList.add('hidden');

        // Competition panelini göster
        const panel = document.getElementById('competition-panel');
        if (panel) {
            panel.classList.remove('hidden');
            console.log("⚔️ Competition panel shown");

            // Panel içi butonları yeniden bağla
            this.setupPanelButtons();
        } else {
            console.error("⚔️ Competition panel not found!");
        }

        this.resetUI();
    },

    setupPanelButtons() {
        // Panel açıldıktan sonra butonları yeniden cache ve bağla
        const playerBtns = document.querySelectorAll('.player-count-btn');
        playerBtns.forEach(btn => {
            btn.onclick = () => {
                playerBtns.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                this.selectedPlayerCount = parseInt(btn.dataset.count);
                console.log(`⚔️ Player count selected: ${this.selectedPlayerCount}`);
            };
        });

        const startBtn = document.getElementById('start-matchmaking-btn');
        if (startBtn) {
            startBtn.onclick = () => this.startSearch();
        }

        const cancelBtn = document.getElementById('cancel-matchmaking-btn');
        if (cancelBtn) {
            cancelBtn.onclick = () => this.cancelSearch();
        }

        const closeBtn = document.getElementById('close-competition-panel');
        if (closeBtn) {
            closeBtn.onclick = () => this.hidePanel();
        }

        // [NEW] Panel yeniden açıldığında start butonunu bağla
        const startGameBtn = document.getElementById('start-game-competition-btn');
        if (startGameBtn) {
            startGameBtn.onclick = () => {
                if (this.currentRoom) {
                    console.log("⚔️ User clicked Start Game -> Sending playerReady");
                    this.currentRoom.send("playerReady");

                    startGameBtn.disabled = true;
                    startGameBtn.innerHTML = "⏳ Diğerleri Bekleniyor...";
                    startGameBtn.classList.remove('pulse-btn');
                }
            };
        }
    },

    hidePanel() {
        const panel = document.getElementById('competition-panel');
        if (panel) {
            panel.classList.add('hidden');
        }
        document.getElementById('lobby-main-actions')?.classList.remove('hidden');

        if (this.isSearching) {
            this.cancelSearch();
        }
    },

    resetUI() {
        const statusContainer = document.getElementById('matchmaking-status');
        const startBtn = document.getElementById('start-matchmaking-btn');

        if (statusContainer) statusContainer.classList.add('hidden');
        if (startBtn) startBtn.classList.remove('hidden');

        // [NEW] Start Game butonunu gizle ve resetle
        const startGameBtn = document.getElementById('start-game-competition-btn');
        if (startGameBtn) {
            startGameBtn.classList.add('hidden');
            startGameBtn.disabled = false;
            startGameBtn.innerHTML = "🚀 HAZIRIM";
            startGameBtn.classList.remove('blue'); // Reset to default state
        }
        const cancelBtn = document.getElementById('cancel-matchmaking-btn');
        if (cancelBtn) cancelBtn.classList.remove('hidden');
    },

    async startSearch() {
        if (this.isSearching) return;

        if (this.isSearching) return;

        this.isSearching = true;
        this.gameStarted = false; // [FIX] Reset flag
        this.disablePlayerCountSelection(true); // [NEW] Kilitle
        this.startTimer(); // [NEW] Timer'ı başlat
        const roomType = `competition`;

        console.log(`⚔️ Starting matchmaking for: ${roomType}`);

        // UI güncelle
        const startBtn = document.getElementById('start-matchmaking-btn');
        const statusContainer = document.getElementById('matchmaking-status');

        if (startBtn) startBtn.classList.add('hidden');
        if (statusContainer) statusContainer.classList.remove('hidden');
        this.updateStatus('Rakip aranıyor...');

        try {
            this.updateStatus('Odaya bağlanılıyor...');

            // Colyseus client check
            if (!window.colyseusClient) {
                console.error("⚔️ Matchmaking Error: window.colyseusClient is null!");
                throw new Error('Bağlantı servislerine erişilemedi.');
            }

            const playerName = window.AuthManager
                ? window.AuthManager.getUsername()
                : `Oyuncu_${Math.random().toString(36).substring(2, 6)}`;

            // Timeout for connection
            const connectionPromise = window.colyseusClient.joinOrCreate(roomType, {
                name: playerName,
                maxPlayers: this.selectedPlayerCount,
                isMobile: /Mobi|Android/i.test(navigator.userAgent)
            });

            const timeoutPromise = new Promise((_, reject) =>
                setTimeout(() => reject(new Error('Bağlantı zaman aşımına uğradı.')), 10000)
            );

            this.currentRoom = await Promise.race([connectionPromise, timeoutPromise]);

            console.log(`⚔️ Successfully joined room: ${this.currentRoom.id}`);

            // Setup listeners
            this.setupRoomListeners();

            // Success UI update
            this.updateStatus(`Oyuncu bekleniyor... (1/${this.selectedPlayerCount})`);

        } catch (error) {
            console.error('⚔️ Matchmaking error:', error);
            this.updateStatus(error.message || 'Eşleşme hatası! Tekrar deneyin.');

            if (this.currentRoom) {
                this.currentRoom.leave();
                this.currentRoom = null;
            }

            this.isSearching = false;
            this.disablePlayerCountSelection(false);
            this.stopTimer();

            setTimeout(() => {
                this.resetUI();
            }, 3000);
        }
    },

    setupRoomListeners() {
        if (!this.currentRoom) return;

        // State değişikliklerini dinle
        this.currentRoom.onStateChange((state) => {
            if (!this.isSearching) return; // ignore if we already stopped or started

            const playerCount = state.players?.size || 0;

            // [NEW] Calculate ready count
            let readyCount = 0;
            if (state.players) {
                state.players.forEach(p => { if (p.ready) readyCount++; });
            }

            // Handle States
            if (state.status === 'ready_check') {
                this.stopTimer();
                this.updateStatus(`OYUN HAZIR! (${readyCount}/${playerCount} Onay)`);

                const startBtn = document.getElementById('start-game-competition-btn');
                const cancelBtn = document.getElementById('cancel-matchmaking-btn');

                if (startBtn) {
                    startBtn.classList.remove('hidden');
                    startBtn.disabled = (this.currentRoom.state.players.get(this.currentRoom.sessionId)?.ready === true);
                    if (startBtn.disabled) {
                        startBtn.innerHTML = "⏳ Diğerleri Bekleniyor...";
                        startBtn.classList.remove('pulse-btn', 'blue');
                    } else {
                        startBtn.innerHTML = "🚀 HAZIRIM";
                        startBtn.classList.add('pulse-btn', 'blue');
                    }
                }
                if (cancelBtn) cancelBtn.classList.add('hidden');
            } else if (state.status === 'waiting') {
                this.updateStatus(`Oyuncu bekleniyor... (${playerCount}/${this.selectedPlayerCount})`);

                const startBtn = document.getElementById('start-game-competition-btn');
                if (startBtn) startBtn.classList.add('hidden');

                const cancelBtn = document.getElementById('cancel-matchmaking-btn');
                if (cancelBtn) cancelBtn.classList.remove('hidden');
            }

            // Oyun başladıysa
            if ((state.status === 'playing' || state.status === 'starting') && !this.gameStarted) {
                console.log(`⚔️ Matchmaking detected state change to ${state.status}. Starting game.`);
                this.onGameStart();
            }
        });

        // Hata durumları
        this.currentRoom.onError((code, message) => {
            console.error(`⚔️ Room error: ${code} - ${message}`);
            this.updateStatus('Bağlantı hatası!');
            this.isSearching = false;
        });

        // Odadan ayrılma
        this.currentRoom.onLeave((code) => {
            console.log(`⚔️ Left room with code: ${code}`);
            if (this.isSearching) {
                this.isSearching = false;
                this.resetUI();
            }
        });
    },

    onGameStart() {
        if (this.gameStarted) return;
        this.gameStarted = true;

        console.log('⚔️ Game starting!');
        this.isSearching = false;
        this.stopTimer(); // [NEW] Timer'ı durdur

        // OnlineGameUI'a odayı aktar
        if (window.OnlineGameUI && this.currentRoom) {
            window.OnlineGameUI.currentRoom = this.currentRoom;
            window.OnlineGameUI.setupRoomListeners(this.currentRoom);
        }

        // Game screen'e geç
        if (window.ui && window.ui.showScreen) {
            window.ui.showScreen('game-screen');
        } else if (window.showScreen) {
            window.showScreen('game-screen');
        } else {
            console.error("Navigation function showScreen not found!");
            // Fallback: try to find the element and show it
            const gameScreen = document.getElementById('game-screen');
            if (gameScreen) {
                document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
                gameScreen.classList.add('active');
            }
        }
        this.hidePanel();
    },

    cancelSearch() {
        console.log('⚔️ Cancelling matchmaking...');

        if (this.currentRoom) {
            this.currentRoom.leave();
            this.currentRoom = null;
        }

        this.isSearching = false;
        this.stopTimer(); // [NEW] Timer'ı durdur
        this.resetUI();
        this.disablePlayerCountSelection(false); // [NEW] Kilit aç
    },

    disablePlayerCountSelection(disabled) {
        const btns = document.querySelectorAll('.player-count-btn');
        btns.forEach(btn => {
            btn.disabled = disabled;
            if (disabled) {
                btn.style.opacity = "0.5";
                btn.style.pointerEvents = "none";
            } else {
                btn.style.opacity = "1";
                btn.style.pointerEvents = "auto";
            }
        });
    },

    startTimer() {
        this.stopTimer();
        this.matchmakingSeconds = 30;

        this.timerInterval = setInterval(() => {
            this.matchmakingSeconds--;
            this.refreshStatusDisplay();

            if (this.matchmakingSeconds <= 0) {
                this.stopTimer();
            }
        }, 1000);
    },

    stopTimer() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        this.matchmakingSeconds = 0;
    },

    // UI'daki metni güncelle (Timer ile birleştirir)
    refreshStatusDisplay() {
        const statusText = document.querySelector('.matchmaking-status .status-text');
        if (!statusText) return;

        let finalTime = "";
        if (this.matchmakingSeconds > 0) {
            finalTime = ` (${this.matchmakingSeconds} sn)`;
        }

        statusText.textContent = `${this.currentStatusText || 'Bekleniyor...'}${finalTime}`;
    },

    updateStatus(text) {
        this.currentStatusText = text;
        this.refreshStatusDisplay();
    }
};

// Global erişim
window.MatchmakingManager = MatchmakingManager;

// Lobby ekranı her gösterildiğinde yeniden init et
// Bu, dinamik DOM render'ı için gerekli
